import { formatAppointmentDateTime } from '@cartwheel/string-utils'

export function AppointmentCard({ startTime }: { startTime?: string | null }) {
  if (!startTime) return null

  return (
    <div className="rounded-lg border border-sand bg-white p-4 shadow-sm">
      <p className="text-xs font-semibold uppercase tracking-wide text-charcoal-50">
        Upcoming appointment
      </p>
      <p className="mt-1 text-sm text-charcoal">
        {formatAppointmentDateTime(startTime, startTime)}
      </p>
    </div>
  )
}
